/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// User & Role Management
import NewRole from "cruds/role-managament/new-role";
import EditUser from "cruds/user-management/edit-user";
import NewUser from "cruds/user-management/new-user";
import EditRole from "cruds/role-managament/edit-role";

// Part Category Management
import NewPartCode from "cruds/part-code-management/part-categories/create-part-category";
import EditPartCategory from "cruds/part-code-management/part-categories/edit-part-category";

// Part Code Management
import NewPart from "cruds/part-code-management/part-codes/create-part-code";
import EditPart from "cruds/part-code-management/part-codes/edit-part-code";
import PartSpecificView from "cruds/part-code-management/part-codes/part-specific-view";

// Inventory Management
import EditInventoryItem from "cruds/Inventory-management/edit-inventory-item";
import SpecificItemView from "cruds/Inventory-management/specific-item-view";
import CreateInventoryItem from "cruds/Inventory-management/create-inventory-item";

// Location Management
import AddLocation from "cruds/location-management/add-location";
import EditLocation from "cruds/location-management/edit-location";

// Fulfillment Center 
import AddProduct from "cruds/fulfillment-center/add-product";
import EditProduct from "cruds/fulfillment-center/edit-product";
import ViewSpecificProduct from "cruds/fulfillment-center/view-specific-product";

/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 PRO React layouts

const crudRoutes = [
  {
    key: "new-role",
    route: "/role-management/new-role",
    component: <NewRole />,
    type: "roles",
  },
  {
    key: "edit-role",
    route: "/role-management/edit-role/:id",
    component: <EditRole />,
    type: "roles",
  },
  {
    key: "new-user",
    route: "/user-management/new-user",
    component: <NewUser />,
    type: "users",
  },
  {
    key: "edit-user",
    route: "/user-management/edit-user/:id",
    component: <EditUser />,
    type: "users",
  },
  // E4A UID Management CRUDS
  {
    key: "create-part-category",
    route: "/part-code-management/create-part-category",
    component: <NewPartCode />,
    type: "create-part-category",
  },
  {
    key: "edit-part-category",
    route: "/part-code-management/edit-part-category/:id",
    component: <EditPartCategory />,
    type: "edit-part-category",
  },
  {
    key: "create-part-code",
    route: "/part-code-management/create-part-code",
    component: <NewPart />,
    type: "create-part-code",
  },
  {
    key: "edit-part-code",
    route: "/part-code-management/edit-part-code/:id",
    component: <EditPart />,
    type: "edit-part-code",
  },
  {
    key: "view-specific-part",
    route: "/part-code-management/view-part-code/:id",
    component: <PartSpecificView />,
  },
  // Inventory Management CRUDS
  {
    name: "Create Inventory Item",
    route: "/inventory-management/create-inventory-item/:partCodeId",
    component: <CreateInventoryItem />,
    type: "create-inventory-item"
  },
  {
    key: "edit-inventory-item",
    route: "/inventory-management/edit-inventory-item/:id",
    component: <EditInventoryItem />,
    type: "edit-inventory-item",
  },
  {
    key: "view-specific-item",
    route: "/inventory-management/view-specific-item/:id",
    component: <SpecificItemView />,
  },
  // Location Management CRUDS
  {
    key: "add-location",
    route: "/location-management/add-location",
    component: <AddLocation />,
    type: "add-location",
  },
  {
    key: "edit-location",
    route: "/location-management/edit-location/:id",
    component: <EditLocation />,
    type: "edit-location",
  },
  // Fulfillment Center CRUDS
  {
    key: "add-product",
    route: "/fulfillment-center/add-product",
    component: <AddProduct />,
    type: "add-product",
  },
  {
    key: "edit-product",
    route: "/fulfillment-center/edit-product/:id",
    component: <EditProduct />,
    type: "edit-product",
  },
  {
    key: "view-specific-product",
    route: "/fulfillment-center/view-product/:id",
    component: <ViewSpecificProduct />,
  }
];

export default crudRoutes;
